<template>
  <v-row>
    <v-col
      class="d-flex align-center justify-start mb-2"
      cols="12"
      sm="9"
    >
      <h1
        ref="title"
        class="focus-invisible fs-36 fw-600 me-4"
        tabindex="0"
      >
        {{ $bct('Hi') }}, {{ firstName }}!
      </h1>
    </v-col>

    <v-col
      v-if="!hubExperience"
      class="d-flex justify-end ga-2"
      cols="12"
      sm="3"
    >
      <StandardButton
        v-if="hasRequestableForms"
        @click="emit('create-new-form')"
        prepend-icon="mail_outline"
        role="secondary"
        size="large"
        text="Submit a form"
        rounded
      />

      <StandardButton
        v-if="!disableNewApplication"
        @click="emit('add-application')"
        custom-classes="focus-very-visible"
        role="create"
        size="large"
        text="New application"
        rounded
      />
    </v-col>
  </v-row>
</template>

<script setup>
defineProps({
  disableNewApplication: {
    type: Boolean,
    default: false,
  },
  firstName: {
    type: String,
    default: null,
  },
  hasRequestableForms: {
    type: Boolean,
    default: false,
  },
  hubExperience: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['add-application', 'add-child', 'create-new-form']);

const $bct = inject('translator');
</script>
